/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { AddTakafulProviderTypes } from "shared/interface/types";
import { RootState } from "redux/store";

const initialState: { Provider: AddTakafulProviderTypes } = {
  Provider: {
    companyName: "",
    contactNumber: "",
    email: "",
    address: "",
    website: "",
    logo: "",
    id: "",
    cityId: 0,
    ntn: "0"
  }
};

const takafulPrividerSlice = createSlice({
  name: "takafulProvider",
  initialState,
  reducers: {
    AddProvider: (state, action) => {
      state.Provider = action.payload;
    },
    DeleteProvider: state => {
      state.Provider = initialState.Provider;
    }
  }
});

export const { AddProvider, DeleteProvider } = takafulPrividerSlice.actions;
export default takafulPrividerSlice.reducer;

export const getProvider = (state: RootState) => state.takafulProvider;
